module.exports = __webpack_public_path__ + "static/media/hiw-icon-recieve-money-se.bd184af0.png";